import { WolfLink } from "@/pages/WolfPage";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown, Map, Swords } from "lucide-react";
import { api } from "@/lib/api";
import { DropBadges } from "@/components/GoldBadge";

const COLL = { c1: "Exclusive", c2: "Wolfpack", c3: "PUPS" };

export default function Showcase() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/showcase").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
      <p className="text-xs uppercase tracking-[0.3em] font-mono-game text-amber-400/90 mb-3">Holder showcase</p>
      <h1 className="font-display text-4xl sm:text-5xl text-white mb-3">The Metaland pack</h1>
      <p className="text-slate-400 mb-10 max-w-2xl">Every holder fighting through the 1,000 regions, shown as the NFT wolf they chose. Hold one yourself to join the gallery.</p>
      {!rows ? <p className="text-slate-500">Gathering the pack…</p> : !rows.length ? (
        <div data-testid="showcase-empty" className="text-center py-16 text-slate-500">
          No holders have joined yet. <Link to="/wallet" className="text-fuchsia-300 hover:underline">Link your wallet</Link> to be the first.
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5" data-testid="showcase-grid">
          {rows.map((r, i) => (
            <article key={r.wolf_name} data-testid={`showcase-card-${i}`} className="group rounded-2xl overflow-hidden border border-slate-800 bg-[#081820]/80 hover:border-amber-400/60 hover:-translate-y-1 transition-[transform,border-color] duration-300">
              <div className="relative aspect-square overflow-hidden">
                <img src={r.portrait} alt={r.wolf_name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  onError={(e) => { e.currentTarget.src = "/art/frost.webp"; }} />
                {r.mwp_tier === "platinum" && <>
                  <div data-testid={`showcase-crown-frame-${i}`} className="absolute inset-0 pointer-events-none border-[5px] border-[#cfeefa] shadow-[inset_0_0_24px_rgba(165,243,252,.6)]" />
                  <Crown className="absolute top-2 left-1/2 -translate-x-1/2 w-10 h-10 text-[#f5d76e] fill-[#f5c518]/80 drop-shadow-[0_2px_6px_rgba(0,0,0,.7)]" strokeWidth={1.6} />
                </>}
                <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/90 to-transparent">
                  <p className="font-display text-xl text-white truncate"><WolfLink name={r.wolf_name} testid={`showcase-link-${i}`} /></p>
                  {(r.exclusive_owner || r.wolfpack_owner || r.mwp_tier) && <div className="flex flex-wrap gap-1 mt-1"><DropBadges o={r} testid={`showcase-${i}`} /></div>}
                  {r.character && <p className="text-[11px] text-amber-300 truncate">as {r.character}</p>}
                </div>
                {r.pack.length > 0 && (
                  <div className="absolute top-2 right-2 flex -space-x-2">
                    {r.pack.map((m) => <img key={m.name} src={m.image} alt={m.name} title={m.name} className="w-8 h-8 rounded-full object-cover border-2 border-[#081820]" />)}
                  </div>
                )}
              </div>
              <div className="p-3 space-y-2">
                <div className="flex justify-between text-xs text-slate-300">
                  <span className="flex items-center gap-1"><Map className="w-3.5 h-3.5 text-cyan-300" />{r.regions_cleared} / 1000</span>
                  <span className="flex items-center gap-1"><Swords className="w-3.5 h-3.5 text-fuchsia-300" />Lv {r.level}</span>
                </div>
                <div className="h-1.5 rounded-full bg-slate-900 overflow-hidden">
                  <div className="h-full bg-gradient-to-r from-fuchsia-500 to-cyan-400" style={{ width: `${Math.max(1, r.regions_cleared / 10)}%` }} />
                </div>
                <div className="flex flex-wrap gap-1">
                  {r.holdings.map((h) => <span key={h} className="px-1.5 py-0.5 rounded bg-amber-500/15 text-amber-200 text-[10px] font-mono-game">{COLL[h]}{r.counts[h] > 1 ? ` ×${r.counts[h]}` : ""}</span>)}
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </main>
  );
}
